"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const recoil_1 = require("recoil");
exports.default = (0, recoil_1.atom)({
    key: 'userInfoState',
    default: {
        user_id: 0,
        channel_id: 0,
        uid: '',
        profile_img_url: '',
        nickname: '',
        email: '',
        credit: 0,
        has_new: false,
        ready: false,
        isLoggedIn: false,
    },
});
